import Typography from '@/ui/components/typography'
import { ItemsListProps } from './ItemsList.types'
import {
    ItemsListWrapper,
    Item,
    ItemBullet,
    ItemText,
} from './ItemsList.styles'

const ItemsList = ({ items, dataTestId }: ItemsListProps) => {
    return (
        <ItemsListWrapper>
            {items.map((itemText, itemIndex) => (
                <Item
                    key={`${itemText}-${itemIndex}`}
                    data-testid={`${dataTestId}-${itemText}`}
                >
                    <ItemBullet />
                    <ItemText>
                        <Typography variant="s-regular">{itemText}</Typography>
                    </ItemText>
                </Item>
            ))}
        </ItemsListWrapper>
    )
}

export default ItemsList
